import { Box } from "@ui/components/layout/box/Box";
import { customCursor } from "@ui/components/media-and-icons/ecco-cursor/EccoCursor";
import { NextImage } from "@ui/components/media-and-icons/image/NextImage";
import { memo } from "react";
import type { Image } from "@graphql/generated/types";
import plus from "@ui/assets/icons/plus.svg";

type ProductImageProps = {
    image: Image;
    imageBackgroundColor: string;
    onImageClick: (index: number) => void;
    currentlySelected: boolean;
    index: number;
    priority: boolean;
    alt: string;
};

export const ProductImage = memo(
    ({
        image,
        onImageClick,
        imageBackgroundColor,
        currentlySelected,
        priority,
        alt,
        index,
    }: ProductImageProps) => {
        return (
            <Box
                background={imageBackgroundColor}
                cursor={customCursor(plus)}
                onClickCapture={() => onImageClick(index)}
                aspectRatio={"4/5"}
                position="absolute"
                top={0}
                w="100%"
                left={0}
                opacity={currentlySelected ? 1 : 0}
                sx={{ transitionProperty: "common", transitionDuration: "slow" }}
                zIndex={currentlySelected ? 1 : 0}
            >
                <NextImage
                    src={image.url}
                    alt={alt}
                    objectFit={"scale-down"}
                    fill={true}
                    priority={priority}
                />
            </Box>
        );
    }
);

ProductImage.displayName = "ProductImage";

export default ProductImage;
